// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_88-4";
export var collapsed = "_88-1";
export var headerBar = "_88-0";
export var leftHeaderContent = "_88-3";
export var subjectContainer = "_88-2";